import GetMFClientContactUseCase from "@domains/features/HelpDesk/useCases/GetMFClientContactUseCase";
export default (function (repositories) {
    return {
        mfHelpDesk: {
            getMfClientContact: new GetMFClientContactUseCase(repositories.mfHelpDesk),
        },
    };
});
